import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getData,
  postData,
  putData,
  deleteData,
} from "../../../../services/apiEndpoints";

export const fetchProject = createAsyncThunk(
  "projectManagement/fetchProject",
  async (projectId, { rejectWithValue }) => {

    try {

      const response = await getData(`project/${projectId}`);

      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: "Server error" });
    }
  }
);

export const createProject = createAsyncThunk(
  "projectManagement/createProject",

  async (projectData, { rejectWithValue }) => {

    try {
      const response = await postData(`/project`, projectData);
      
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: "Server error" });
    }
  }
);

export const fetchProjects = createAsyncThunk(
  "projectManagement/fetchProjects",
  async (_, { rejectWithValue }) => {

    try {
      const response = await getData(`/project/projects/all`);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: "Server error" });
    }
  }
);


export const updateProject = createAsyncThunk(
  "projectManagement/updateProject",
  async ({ id, data }, { rejectWithValue }) => {

    try {
      const response = await putData(`project/${id}`, data);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: "Server error" });
    }
  }
);

export const deleteProject = createAsyncThunk(
  "projectManagement/deleteProject",
  async (id, { rejectWithValue }) => {

    try {
      const response = await deleteData(`project/delete-project/${id}`);
      return { id, ...response };
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: "Server error" });
    }
  }
);

//task
export const createTask = createAsyncThunk(
  "projectManagement/createTask",
  async (data, { rejectWithValue }) => {

    try {
      const response = await postData(`project/${data.projectId}/tasks`, data);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: "Server error" });
    }
  }
);

export const fetchTasks = createAsyncThunk(
  "projectManagement/fetchTasks",
  async (projectId = "", { rejectWithValue }) => {

    try {
      const url = projectId
        ? `project/get-tasks/${projectId}`
        : `project/get-tasks`;
      const response = await getData(url);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: "Server error" });
    }
  }
);


export const updateTask = createAsyncThunk(
  "projectManagement/updateTask",
  async ({ id, data }, { rejectWithValue }) => {

    try {
      const response = await putData(`project/${id}/tasks`, data);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: "Server error" });
    }
  }
);


export const deleteTask = createAsyncThunk(
  "projectManagement/deleteTask",
  async (id, { rejectWithValue }) => {

    try {
      const response = await deleteData(`project/delete-task/${id}`);
      return { id, ...response };
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: "Server error" });
    }
  }
);

export const addTaskComment = createAsyncThunk(
  "projectManagement/addTaskComment",
  async ({ projectId, taskId, message }, { rejectWithValue }) => {

    try {
      const response = await postData(`project/${projectId}/tasks/${taskId}/comments`, message);
      return response;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: "Server error" });
    }
  }
);

export const fetchProjectAnalytics = createAsyncThunk(
  "projectManagement/fetchProjectAnalytics",
  async (projectId, { rejectWithValue }) => {
    try {
      const response = await getData(`project/${projectId}/analytics`);
      return response.data; // 👈 only analytics data
    } catch (err) {
      return rejectWithValue(
        err.response?.data || { message: "Server error" }
      );
    }
  }
);